import { image, premierePage } from './tampon';

/** Largeur gardée du bulletin, en pixels : lisible au guichet, léger à envoyer. */
export const LARGEUR_BULLETIN = 1600;

/** Hauteur de la partie paiement d'une page A4 suisse : 105 mm sur 297. */
const PART_PAIEMENT = 105 / 297;

/**
 * Prépare le bulletin de versement que la banque a remis à l'entreprise.
 *
 * <p>La banque le donne en PDF ou sur papier (photo) : soit le bulletin seul,
 * soit une page A4 entière avec le bulletin au bas, à l'endroit fixé par la
 * norme. Une page en hauteur est donc ramenée à sa partie paiement, les
 * 105 mm du bas ; un bulletin seul (plus large que haut) est gardé entier.
 *
 * @param {File|Blob} fichier le PDF ou la photo choisi
 * @returns {Promise<string>} le bulletin en JPEG (adresse data:)
 */
export async function prepareBulletin(fichier) {
  const estPdf = fichier.type === 'application/pdf' || /\.pdf$/i.test(fichier.name || '');
  const c = estPdf ? await premierePage(fichier) : await image(fichier);
  const page = c.height > c.width * 1.2;
  const haut = page ? Math.round(c.height * (1 - PART_PAIEMENT)) : 0;
  const hauteur = c.height - haut;
  const echelle = Math.min(1, LARGEUR_BULLETIN / c.width);
  const sortie = document.createElement('canvas');
  sortie.width = Math.max(1, Math.round(c.width * echelle));
  sortie.height = Math.max(1, Math.round(hauteur * echelle));
  const ctx = sortie.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, sortie.width, sortie.height);
  ctx.drawImage(c, 0, haut, c.width, hauteur, 0, 0, sortie.width, sortie.height);
  return sortie.toDataURL('image/jpeg', 0.85);
}
